import React, { Fragment } from 'react';
import { isText, isElement } from '@graphcms/rich-text-types';
import escapeHtml from 'escape-html';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function IFrame(_ref) {
  var url = _ref.url;
  return React.createElement("div", {
    style: {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      paddingTop: '56.25%'
    }
  }, React.createElement("iframe", {
    style: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    src: escapeHtml(url),
    loading: "lazy",
    allow: "fullscreen",
    frameBorder: "0",
    referrerPolicy: "no-referrer"
  }));
}
function Image(_ref) {
  var src = _ref.src,
    width = _ref.width,
    height = _ref.height,
    altText = _ref.altText,
    title = _ref.title;
  return React.createElement("img", {
    loading: "lazy",
    src: escapeHtml(src),
    width: width,
    height: height,
    alt: altText,
    title: title
  });
}
function Video(_ref) {
  var src = _ref.src,
    width = _ref.width,
    height = _ref.height,
    title = _ref.title;
  return React.createElement("video", {
    src: escapeHtml(src),
    controls: true,
    width: width || '100%',
    height: height || '100%',
    title: title
  }, React.createElement("p", null, "Your browser doesn't support HTML5 video. Here is a", ' ', React.createElement("a", {
    href: src
  }, "link to the video"), " instead."));
}
function Class(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return React.createElement("div", {
    className: className
  }, children);
}
function Link(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, ["children"]);
  var href = rest.href,
    rel = rest.rel,
    id = rest.id,
    title = rest.title,
    openInNewTab = rest.openInNewTab,
    className = rest.className;
  var props = {};
  if (rel) props.rel = rel;
  if (id) props.id = id;
  if (title) props.title = title;
  if (className) props.className = className;
  if (openInNewTab) props.target = '_blank';
  return React.createElement("a", Object.assign({
    href: escapeHtml(href)
  }, props), children);
}
var defaultElements = {
  a: Link,
  "class": Class,
  video: Video,
  img: Image,
  iframe: IFrame,
  blockquote: function blockquote(_ref) {
    var children = _ref.children;
    return React.createElement("blockquote", null, children);
  },
  ul: function ul(_ref2) {
    var children = _ref2.children;
    return React.createElement("ul", null, children);
  },
  ol: function ol(_ref3) {
    var children = _ref3.children;
    return React.createElement("ol", null, children);
  },
  li: function li(_ref4) {
    var children = _ref4.children;
    return React.createElement("li", null, children);
  },
  p: function p(_ref5) {
    var children = _ref5.children;
    return React.createElement("p", null, children);
  },
  h1: function h1(_ref6) {
    var children = _ref6.children;
    return React.createElement("h1", null, children);
  },
  h2: function h2(_ref7) {
    var children = _ref7.children;
    return React.createElement("h2", null, children);
  },
  h3: function h3(_ref8) {
    var children = _ref8.children;
    return React.createElement("h3", null, children);
  },
  h4: function h4(_ref9) {
    var children = _ref9.children;
    return React.createElement("h4", null, children);
  },
  h5: function h5(_ref10) {
    var children = _ref10.children;
    return React.createElement("h5", null, children);
  },
  h6: function h6(_ref11) {
    var children = _ref11.children;
    return React.createElement("h6", null, children);
  },
  table: function table(_ref12) {
    var children = _ref12.children;
    return React.createElement("table", null, children);
  },
  table_head: function table_head(_ref13) {
    var children = _ref13.children;
    return React.createElement("thead", null, children);
  },
  table_body: function table_body(_ref14) {
    var children = _ref14.children;
    return React.createElement("tbody", null, children);
  },
  table_row: function table_row(_ref15) {
    var children = _ref15.children;
    return React.createElement("tr", null, children);
  },
  table_cell: function table_cell(_ref16) {
    var children = _ref16.children;
    return React.createElement("td", null, children);
  },
  bold: function bold(_ref17) {
    var children = _ref17.children;
    return React.createElement("b", null, children);
  },
  italic: function italic(_ref18) {
    var children = _ref18.children;
    return React.createElement("i", null, children);
  },
  underline: function underline(_ref19) {
    var children = _ref19.children;
    return React.createElement("u", null, children);
  },
  code: function code(_ref20) {
    var children = _ref20.children;
    return React.createElement("code", null, children);
  },
  list_item_child: function list_item_child(_ref21) {
    var children = _ref21.children;
    return React.createElement(React.Fragment, null, children);
  }
};
var defaultRemoveEmptyElements = {
  h1: true,
  h2: true,
  h3: true,
  h4: true,
  h5: true,
  h6: true,
  table_head: true
};
var elementKeys = {
  'heading-one': 'h1',
  'heading-two': 'h2',
  'heading-three': 'h3',
  'heading-four': 'h4',
  'heading-five': 'h5',
  'heading-six': 'h6',
  "class": 'class',
  link: 'a',
  image: 'img',
  iframe: 'iframe',
  video: 'video',
  'bulleted-list': 'ul',
  'numbered-list': 'ol',
  'list-item': 'li',
  'list-item-child': 'list_item_child',
  table: 'table',
  table_head: 'table_head',
  table_body: 'table_body',
  table_row: 'table_row',
  table_cell: 'table_cell',
  'block-quote': 'blockquote',
  paragraph: 'p',
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  code: 'code'
};
function RenderText(_ref) {
  var textNode = _ref.textNode,
    renderers = _ref.renderers;
  var text = textNode.text,
    bold = textNode.bold,
    italic = textNode.italic,
    underline = textNode.underline,
    code = textNode.code;
  var Bold = renderers == null ? void 0 : renderers[elementKeys['bold']];
  var Italic = renderers == null ? void 0 : renderers[elementKeys['italic']];
  var Underline = renderers == null ? void 0 : renderers[elementKeys['underline']];
  var Code = renderers == null ? void 0 : renderers[elementKeys['code']];
  var element = text;
  if (bold && Bold) {
    element = React.createElement(Bold, null, element);
  }
  if (italic && Italic) {
    element = React.createElement(Italic, null, element);
  }
  if (underline && Underline) {
    element = React.createElement(Underline, null, element);
  }
  if (code && Code) {
    element = React.createElement(Code, null, element);
  }
  return React.createElement(React.Fragment, null, element);
}
function RenderNode(_ref) {
  var node = _ref.node,
    renderers = _ref.renderers;
  if (isText(node)) {
    return React.createElement(RenderText, {
      textNode: node,
      renderers: renderers
    });
  }
  if (isElement(node)) {
    return React.createElement(RenderElement, {
      element: node,
      renderers: renderers
    });
  }
  var type = node.type;
  if (process.env.NODE_ENV !== "production") {
    console.warn("[@graphcms/rich-text-react-renderer]: Unknown node type encountered: " + type);
  }
  return React.createElement(Fragment, null);
}
function RenderElement(_ref2) {
  var element = _ref2.element,
    renderers = _ref2.renderers;
  var children = element.children,
    type = element.type,
    rest = _objectWithoutPropertiesLoose(element, ["children", "type"]);
  if (defaultRemoveEmptyElements != null && defaultRemoveEmptyElements[elementKeys[type]] && children[0].text === '') {
    return React.createElement(Fragment, null);
  }
  var NodeRenderer = renderers == null ? void 0 : renderers[elementKeys[type]];
  if (NodeRenderer) {
    return React.createElement(NodeRenderer, Object.assign({}, rest), React.createElement(RichText, {
      content: children,
      renderers: renderers
    }));
  }
  return React.createElement(Fragment, null);
}
function RichText(_ref3) {
  var content = _ref3.content,
    resolvers = _ref3.renderers;
  var renderers = _extends({}, defaultElements, resolvers);
  if (process.env.NODE_ENV !== "production" && !content) {
    console.error("[@graphcms/rich-text-react-renderer]: content is required.");
    return React.createElement(Fragment, null);
  }
  if (process.env.NODE_ENV !== "production" && !Array.isArray(content) && !content.children) {
    console.error("[@graphcms/rich-text-react-renderer]: children is required.");
    return React.createElement(Fragment, null);
  }
  var elements = Array.isArray(content) ? content : content.children;
  return React.createElement(React.Fragment, null, elements.map(function (node, index) {
    return React.createElement(RenderNode, {
      node: node,
      renderers: renderers,
      key: index
    });
  }));
}
export { RichText };